module.exports = __webpack_public_path__ + "img/bank5.cd223024.png";